<template>
  <div>
    <b-row>
      <b-col cols="12">
        <b-overlay :show="isLoading" rounded="sm">
          <b-card class="shadow-sm pt-0 pl-0 pr-0 m-4 mb-0">
            <b-navbar toggleable="lg">
              <b-navbar-brand href="#">
                <strong style="color:#3b3e66">Custom Fields</strong>
              </b-navbar-brand>

              <b-navbar-nav class="ml-auto">
                <b-nav-form>
                  <!-- @click="showModal = !showModal" -->
                  <b-button
                    class="my-2 my-sm-0 mr-2"
                    variant="outline-primary"
                    size="sm"
                    @click="showAddFieldsModal = !showAddFieldsModal"
                  >
                    <font-awesome-icon icon="plus" />
                  </b-button>
                  <b-button variant="outline-info" size="sm" class="mr-2" @click="reloadTable">
                    <font-awesome-icon icon="sync" />
                  </b-button>
                  <b-form-group
                    label-cols-sm="3"
                    label-align-sm="right"
                    label-size="sm"
                    label-for="filterInput"
                  >
                    <b-input-group size="sm">
                      <b-form-input
                        v-model="filter"
                        type="search"
                        id="filterInput"
                        placeholder="Type to Search"
                      ></b-form-input>
                      <b-input-group-append>
                        <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
                      </b-input-group-append>
                    </b-input-group>
                  </b-form-group>
                </b-nav-form>
              </b-navbar-nav>
            </b-navbar>

            <b-table
              sticky-header="calc(100vh - 200px)"
              ref="table"
              bordered
              id="users-data-table"
              :busy.sync="isLoading"
              :items="getCustomFieldData"
              :fields="fields"
              :filter="filter"
              :per-page="perPage"
              :current-page="currentPage"
              :sort-by.sync="sortBy"
              :sort-desc.sync="sortDesc"
              responsive="sm"
            >
              <template v-slot:cell(values)="data">
                <div>
                  <p
                    v-for="(metaValue,metaIndex) in JSON.parse(data.item.meta_data).value"
                    :key="metaIndex"
                  >{{metaValue}}</p>
                </div>
              </template>
              <template v-slot:cell(actions)="data">
                <b-button
                  class="mr-2"
                  type="button"
                  variant="info"
                  @click="onEditCustomField(data)"
                >
                  <font-awesome-icon
                    v-b-tooltip.hover
                    title="Edit Field"
                    class="mr-1 text-light"
                    icon="edit"
                  />Edit
                </b-button>
                <b-button type="button" variant="danger" @click="onDeleteCustomField(data)">
                  <font-awesome-icon
                    v-b-tooltip.hover
                    title="Delete Field"
                    class="mr-1 text-light"
                    icon="trash"
                  />Delete
                </b-button>
              </template>
            </b-table>
            <template v-slot:footer>
              <b-row>
                <b-col cols="2">
                  <b-form-select
                    v-model="perPage"
                    id="perPageSelect"
                    size="sm"
                    :options="pageOptions"
                  ></b-form-select>
                </b-col>
                <b-col cols="6">
                  <p class="text-center">
                    Showing Result From
                    <b>{{fromRows}}</b> to
                    <b>{{toRows}}</b>
                  </p>
                </b-col>
                <b-col cols="4">
                  <b-pagination
                    class="float-right"
                    v-model="currentPage"
                    :total-rows="rows"
                    :per-page="perPage"
                    first-text="First"
                    prev-text="Prev"
                    next-text="Next"
                    last-text="Last"
                    aria-controls="my-table"
                  ></b-pagination>
                </b-col>
              </b-row>
            </template>
          </b-card>
        </b-overlay>
      </b-col>
    </b-row>
    <b-modal
      :title="editForm ? 'Edit Fields' : 'Add Fields'"
      id="bv-modal-newform"
      size="xl"
      v-model="showAddFieldsModal"
      scrollable
      no-close-on-backdrop
      no-close-on-esc
      hide-header-close
    >
      <div>
        <b-form v-if="!submiting && !responseSuccess">
          <b-form-group>
            <b-row>
              <b-col cols="3">
                <label>
                  Field Title :
                  <span class="text-danger">*</span>
                </label>
              </b-col>
              <b-col cols="9">
                <b-form-input
                  v-model="$v.form.fieldTitle.$model"
                  :state="$v.form.fieldTitle.$dirty ? !$v.form.fieldTitle.$error : null"
                  type="text"
                  placeholder="Enter Field Title"
                ></b-form-input>
              </b-col>
            </b-row>
          </b-form-group>

          <b-form-group>
            <b-row>
              <b-col cols="3">
                <label>Abbreviation Text :</label>
              </b-col>
              <b-col cols="9">
                <b-form-input
                  v-model="form.abbreviationText"
                  type="text"
                  placeholder="Enter Abbreviation Text"
                ></b-form-input>
              </b-col>
            </b-row>
          </b-form-group>

          <b-form-group>
            <b-row>
              <b-col cols="3">
                <label>
                  Data Type :
                  <span class="text-danger">*</span>
                </label>
              </b-col>
              <b-col cols="9">
                <b-form-select
                  v-model="$v.form.dataType.$model"
                  :state="$v.form.dataType.$dirty ? !$v.form.dataType.$error : null"
                  aria-describedby="input-live-help input-live-feedback"
                  :options="dataTypeOptions"
                  class="mb-3"
                ></b-form-select>
              </b-col>
            </b-row>
          </b-form-group>

          <b-form-group
            v-if="form.dataType != 'Text' && form.dataType != 'Date' && form.dataType != 'Country List'"
          >
            <b-row>
              <b-col cols="3">
                <label>Data Values :</label>
              </b-col>
              <b-col cols="9">
                <b-row>
                  <b-col cols="6">
                    <label>Label</label>
                  </b-col>
                  <b-col cols="6">
                    <label>Values</label>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col cols="10">
                    <div v-for="(cloenFields,index) in dataValuesArray" :key="index">
                      <b-row class="mt-2">
                        <b-col cols="6">
                          <b-form-input v-model="form.dataArrayLabel[index]" type="text"></b-form-input>
                        </b-col>
                        <b-col cols="6">
                          <b-input-group>
                            <b-form-input
                              :class="getValidationColor ? 'border border-danger rounded' : null"
                              v-model="form.dataArrayValue[index]"
                              @input="checkCustomValidation()"
                              type="text"
                            ></b-form-input>
                            <template v-slot:append>
                              <b-button
                                variant="outline-danger"
                                v-if="index > 0"
                                class="btn btn-outline-danger btn-sm"
                                @click="onDeleteOption(index)"
                              >
                                <i class="fa fa-trash"></i>
                              </b-button>
                            </template>
                          </b-input-group>
                        </b-col>
                      </b-row>
                    </div>
                  </b-col>
                  <b-col cols="1">
                    <b-button class="mt-2" variant="primary" @click="addOption">
                      <i class="fa fa-plus"></i>
                    </b-button>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
          </b-form-group>
        </b-form>
        <div v-else-if="submiting && !responseSuccess">
          <p>{{ editForm ? 'Your Custom Field is being updating......' : 'Your Custom Field is being added......' }}</p>
          <b-spinner type="grow" label="Loading..."></b-spinner>
        </div>
        <div v-else>
          <p class="my-2 text-center">
            {{ editForm ? 'Your Custom Field has been updated successfully.' : 'Your Custom Field has been added successfully.' }}
            <br />
          </p>
        </div>
      </div>
      <template v-slot:modal-footer>
        <b-button
          variant="outline-danger"
          @click="resetForm"
        >{{!submiting && responseSuccess ? 'Close' : 'Cancel' }}</b-button>
        <b-button
          v-if="!submiting && !responseSuccess"
          variant="outline-success"
          @click="checkValidation"
        >{{ editForm ? 'Update' : 'Save' }}</b-button>
      </template>
    </b-modal>
    <b-overlay :show="showDeleteFieldOverlay" no-wrap>
      <template v-slot:overlay>
        <div v-if="processing" class="text-center p-4 bg-primary text-light rounded">
          <font-awesome-icon size="lg" icon="cloud-upload-alt" />
          <div class="mb-3">Deleting...</div>
          <b-progress
            min="1"
            max="20"
            :value="counter"
            variant="success"
            height="3px"
            class="mx-n4 rounded-0"
          ></b-progress>
        </div>
        <div
          v-else
          ref="dialog"
          tabindex="-1"
          role="dialog"
          aria-modal="false"
          aria-labelledby="form-confirm-label"
          class="text-center p-3"
        >
          <p>
            <strong id="form-confirm-label">Are you sure?</strong>
          </p>
          <div class="d-flex">
            <b-button variant="outline-success" class="mr-3" @click="resetDeleteModal">Cancel</b-button>
            <b-button variant="outline-danger" @click="deleteCustomFieldCall">Yes</b-button>
          </div>
        </div>
      </template>
    </b-overlay>
  </div>
</template>

<script>
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
import { HTTP } from "../../../utils/HTTP";
export default {
  name: "CustomFields",
  mixins: [validationMixin],
  data() {
    return {
      showDeleteFieldOverlay: false,
      customFieldId: null,
      form: {
        fieldTitle: null,
        abbreviationText: null,
        dataType: "Dropdown",
        dataArrayLabel: [],
        dataArrayValue: [],
      },
      dataValuesArray: [1],
      showAddFieldsModal: false,
      dataTypeOptions: [
        {
          value: "Dropdown",
          text: "Dropdown",
        },
        {
          value: "Multiselect",
          text: "Multiselect",
        },
        {
          value: "Text",
          text: "Text",
        },
        {
          value: "Date",
          text: "Date",
        },
        {
          value: "Country List",
          text: "Country List",
        },
      ],
      fromRows: 0,
      toRows: 0,
      editForm: false,
      perPage: 10,
      totalRows: 0,
      currentPage: 1,
      sortBy: "id",
      sortDesc: false,
      pageOptions: [5, 10, 25, 50, 75, 100],
      items: [],
      isLoading: false,
      submiting: false,
      responseSuccess: false,
      filter: null,
      fields: [
        {
          key: "custom_fields_title",
          label: "Custom Field",
          sortable: true,
        },
        {
          key: "abbreviation",
          label: "Abbreviation Text",
          sortable: true,
        },
        {
          key: "type",
          label: "Data Type",
          sortable: true,
        },
        {
          key: "values",
          label: "Data Values",
          sortable: false,
        },
        {
          key: "actions",
          label: "Actions",
          sortable: false,
        },
      ],
      customAtFormValueValidation: true,
      getValidationColor: false,
      processing: false,
      counter: 1,
      interval: null,
    };
  },
  validations: {
    form: {
      fieldTitle: {
        required,
      },
      dataType: {
        required,
      },
    },
  },
  computed: {
    rows() {
      return this.totalRows;
    },
  },
  beforeDestroy() {
    this.clearInterval();
  },
  methods: {
    clearInterval() {
      if (this.interval) {
        clearInterval(this.interval);
        this.interval = null;
      }
    },
    reloadTable() {
      this.$root.$emit("bv::refresh::table", "users-data-table");
    },
    async getCustomFieldData() {
      let formData = {
        filter: this.filter,
        sort: this.sortBy + "|" + (this.sortDesc == true ? "desc" : "asc"),
        per_page: this.perPage,
        page: this.currentPage,
      };
      this.isLoading = true;
      let token = "Bearer " + localStorage.getItem("accessToken");
      let result = HTTP("post", "api/v1/custom/field/get", formData, {
        Authorization: token,
      });

      return result
        .then((response) => {
          const items = response.data.data;
          this.isLoading = false;
          this.fromRows = response.data.from;
          this.toRows = response.data.to;
          this.totalRows = response.data.total;
          return items;
        })
        .catch((error) => {
          this.isLoading = false;
          return [error];
        });
    },
    checkCustomValidation() {
      this.customAtFormValueValidation = false;
      this.getValidationColor = false;
    },
    addOption() {
      if (this.customAtFormValueValidation) {
        this.getValidationColor = true;
      } else if (this.customAtFormValueValidation == false) {
        this.customAtFormValueValidation = true;
        this.dataValuesArray.push(1);
      }
    },
    onDeleteOption(index) {
      this.dataValuesArray.splice(this.dataValuesArray.indexOf(index), 1);
      this.form.dataArrayLabel.splice(
        this.form.dataArrayLabel.indexOf(index),
        1
      );
    },
    checkValidation() {
      this.$v.form.$touch();
      if (this.$v.form.$anyError) {
        return;
      } else if (this.editForm) {
        this.updateCustomField().then(this.reloadTable);
      } else {
        this.addCustomField().then(this.reloadTable);
      }
    },
    showAddModal() {
      this.editForm = false;
      this.showAddFieldsModal = true;
    },
    async addCustomField() {
      let metaData = {
        label: this.form.dataArrayLabel,
        value: this.form.dataArrayValue,
      };
      let formData = {
        custom_fields_title: this.form.fieldTitle,
        abbreviation: this.form.abbreviationText,
        type: this.form.dataType,
        meta_data: metaData,
        user_id: localStorage.getItem("userId"),
      };
      try {
        let token = "Bearer " + localStorage.getItem("accessToken");
        this.submiting = true;
        this.isLoading = true;
        let result = await HTTP(
          "post",
          "api/v1/custom/field/create",
          formData,
          {
            Authorization: token,
          }
        );
        this.submiting = false;
        this.isLoading = false;
        this.responseSuccess = true;
      } catch (error) {
        this.submiting = false;
        this.isLoading = false;
        this.responseSuccess = false;
      }
    },
    async updateCustomField() {
      let metaData = {
        label: this.form.dataArrayLabel,
        value: this.form.dataArrayValue,
      };
      let formData = {
        custom_field_id: this.customFieldId,
        custom_fields_title: this.form.fieldTitle,
        abbreviation: this.form.abbreviationText,
        type: this.form.dataType,
        meta_data: metaData,
        user_id: localStorage.getItem("userId"),
      };
      try {
        let token = "Bearer " + localStorage.getItem("accessToken");
        this.submiting = true;
        this.isLoading = true;
        let result = await HTTP(
          "post",
          "api/v1/custom/field/update",
          formData,
          {
            Authorization: token,
          }
        );
        this.submiting = false;
        this.isLoading = false;
        this.responseSuccess = true;
      } catch (error) {
        this.submiting = false;
        this.isLoading = false;
        this.responseSuccess = false;
      }
    },
    resetForm() {
      this.responseSuccess = false;
      this.submiting = false;
      this.isLoading = false;
      this.form.fieldTitle = null;
      this.form.dataType = "Dropdown";
      this.form.abbreviationText = null;
      this.form.dataArrayLabel = [];
      this.form.dataArrayValue = [];
      this.$v.$reset();
      this.dataValuesArray = [1];
      this.editForm = false;
      this.customFieldId = null;
      this.showAddFieldsModal = false;
    },
    onEditCustomField(data) {
      this.editForm = true;
      this.dataValuesArray = [];
      this.customFieldId = data.item.id;
      let metaData = JSON.parse(data.item.meta_data);
      metaData.value.map((metaValue, index) => {
        this.dataValuesArray.push(index);
      });
      if (metaData.value.length) {
        this.customAtFormValueValidation = false;
      } else {
        this.customAtFormValueValidation = true;
        this.dataValuesArray = [1];
      }
      this.form = {
        fieldTitle: data.item.custom_fields_title,
        dataType: data.item.type,
        abbreviationText: data.item.abbreviation,
        dataArrayLabel: metaData.label,
        dataArrayValue: metaData.value,
      };
      this.showAddFieldsModal = true;
    },
    onDeleteCustomField(data) {
      this.customFieldId = data.item.id;
      this.processing = false;
      this.showDeleteFieldOverlay = true;
    },
    deleteCustomFieldCall() {
      this.counter = 1;
      this.processing = true;
      this.deleteCustomFieldApiCall().then(this.reloadTable);
      this.clearInterval();
      this.interval = setInterval(() => {
        if (this.counter < 20) {
          this.counter = this.counter + 1;
        } else {
          this.clearInterval();
          this.$nextTick(() => {
            this.resetDeleteModal();
          });
        }
      }, 150);
    },
    async deleteCustomFieldApiCall() {
      try {
        let token = "Bearer " + localStorage.getItem("accessToken");
        await HTTP(
          "get",
          "api/v1/custom/field/delete/" + this.customFieldId,
          null,
          {
            Authorization: token,
          }
        );
      } catch (error) {
        this.isLoading = false;
      }
    },
    resetDeleteModal() {
      this.customFieldId = null;
      this.showDeleteFieldOverlay = this.processing = false;
    },
  },
};
</script>
<style scoped>
.card-body {
  padding: 0px;
}
</style>
